export function getFractionCurrencyFormatter(marketSettings) {
    if(marketSettings.CurrencySymbolAbbreviation) {
        return new Intl.NumberFormat(marketSettings.LocaleName, {
            style: 'currency',
            currency: marketSettings.Currency,
            currencyDisplay: 'code',
            minimumFractionDigits: marketSettings.MinimumFractionDigits,
            maximumFractionDigits: marketSettings.MaximumFractionDigits
        });
    }
    return new Intl.NumberFormat(marketSettings.LocaleName, {
        style: 'currency',
        currency: marketSettings.Currency,
        minimumFractionDigits: marketSettings.MinimumFractionDigits,
        maximumFractionDigits: marketSettings.MaximumFractionDigits
    });
}

export function getCurrencyFormatter(marketSettings) {
    let minimumFractionDigits = marketSettings.MinimumFractionDigits &&
        Number(marketSettings.MinimumFractionDigits) > Number(marketSettings.MaximumDecimalsForWholeNumber)
        ? marketSettings.MaximumDecimalsForWholeNumber
        : marketSettings.MinimumFractionDigits;
    if(marketSettings.CurrencySymbolAbbreviation) {
        return new Intl.NumberFormat(marketSettings.LocaleName, {
            style: 'currency',
            currency: marketSettings.Currency,
            currencyDisplay: 'code',
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: marketSettings.MaximumDecimalsForWholeNumber
        });
    }
    return new Intl.NumberFormat(marketSettings.LocaleName, {
        style: 'currency',
        currency: marketSettings.Currency,
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: marketSettings.MaximumDecimalsForWholeNumber
    });
}
